export default "__VITE_ASSET__Dxn$wjkM__"